
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        initDealersMap();
    });

    function initDealersMap() {
        const root = document.querySelector('[data-dealers-map]');
        if (!root || typeof L === 'undefined') return;

        const mapEl = root.querySelector('#dealers-map');
        const items = Array.from(root.querySelectorAll('[data-dealer-item]'));
        const dealers = parseDealers(root.dataset.dealersJson);
        if (!mapEl || !dealers.length) return;

        const map = L.map(mapEl, {
            center: [52.0, 19.0],
            zoom: 6,
            scrollWheelZoom: false,
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            maxZoom: 19,
        }).addTo(map);

        const byId = new Map();
        const markers = [];

        dealers.forEach(function (d) {
            const marker = L.marker([d.lat, d.lng]).addTo(map);
            const popup = renderPopup(d);
            marker.bindPopup(popup);
            markers.push(marker);
            const li = items.find(function (el) {
                return parseInt(el.dataset.dealerId, 10) === d.id;
            });
            byId.set(d.id, { marker: marker, li: li, data: d });
        });

        if (markers.length > 1) {
            const group = L.featureGroup(markers);
            map.fitBounds(group.getBounds(), { padding: [40, 40], maxZoom: 10 });
        } else if (markers.length === 1) {
            map.setView([dealers[0].lat, dealers[0].lng], 10);
        }

        items.forEach(function (li) {
            li.addEventListener('click', function (e) {
                if (e.target.closest('a')) return;
                const id = parseInt(li.dataset.dealerId, 10);
                const entry = byId.get(id);
                if (!entry) return;
                map.setView(entry.marker.getLatLng(), 12, { animate: true });
                entry.marker.openPopup();
                highlightDealer(id, byId);
            });
        });

        initDistanceFilter(root, byId, map);
    }

    function parseDealers(raw) {
        if (!raw) return [];
        try {
            return JSON.parse(raw);
        } catch (e) {
            console.error('[dealers-map] Invalid JSON:', e);
            return [];
        }
    }

    function renderPopup(d) {
        const html = document.createElement('div');
        const parts = ['<strong>' + escapeHtml(d.name) + '</strong>'];
        if (d.address) parts.push(escapeHtml(d.address));
        if (d.phone)   parts.push('<a href="tel:' + escapeHtml(d.phone.replace(/\s+/g, '')) + '">' + escapeHtml(d.phone) + '</a>');
        html.innerHTML = parts.join('<br>');
        return html;
    }

    function highlightDealer(id, byId) {
        byId.forEach(function (entry, key) {
            if (entry.li) entry.li.classList.toggle('is-highlighted', key === id);
        });
    }

    function initDistanceFilter(root, byId, map) {
        const buttons = root.parentElement.querySelectorAll('[data-dealer-filter]');
        const countEl = root.querySelector('[data-dealers-count]');
        if (!buttons.length) return;

        let userLoc = null;
        let userMarker = null;

        buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const value = btn.dataset.dealerFilter;
                buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });

                if (value === 'all') {
                    applyFilter(byId, null, countEl);
                    if (userMarker) { map.removeLayer(userMarker); userMarker = null; }
                    return;
                }

                const maxKm = parseInt(value, 10);
                if (userLoc) {
                    applyFilter(byId, { origin: userLoc, maxKm: maxKm }, countEl);
                    return;
                }

                if (!navigator.geolocation) {
                    alert('Twoja przeglądarka nie wspiera geolokalizacji.');
                    return;
                }

                navigator.geolocation.getCurrentPosition(
                    function (pos) {
                        userLoc = [pos.coords.latitude, pos.coords.longitude];
                        userMarker = L.circleMarker(userLoc, {
                            radius: 8, color: '#ff8c00', fillColor: '#ff8c00', fillOpacity: 0.8, weight: 2,
                        }).addTo(map).bindPopup('Twoja lokalizacja');
                        map.setView(userLoc, 8);
                        applyFilter(byId, { origin: userLoc, maxKm: maxKm }, countEl);
                    },
                    function (err) {
                        console.warn('[dealers-map] geolocation denied/failed:', err);
                        alert('Aby filtrować po odległości, włącz dostęp do lokalizacji w przeglądarce.');

                        buttons.forEach(function (b) {
                            b.classList.toggle('is-active', b.dataset.dealerFilter === 'all');
                        });
                    }
                );
            });
        });
    }

    function applyFilter(byId, filter, countEl) {
        let visible = 0;
        byId.forEach(function (entry) {
            let show = true;
            if (filter) {
                const km = haversine(filter.origin[0], filter.origin[1], entry.data.lat, entry.data.lng);
                show = km <= filter.maxKm;
            }
            if (entry.li) entry.li.hidden = !show;
            if (show) visible++;
        });
        if (countEl) countEl.textContent = String(visible);
    }

    function haversine(lat1, lng1, lat2, lng2) {
        const R = 6371;
        const toRad = function (deg) { return deg * Math.PI / 180; };
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);
        const a = Math.sin(dLat / 2) ** 2 +
                  Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                  Math.sin(dLng / 2) ** 2;
        return 2 * R * Math.asin(Math.sqrt(a));
    }

    function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }
})();
